<template>
  <div style="margin-left: 30px">
    <loading :active.sync="this.spinnerVisible"
             :opacity="1"
             loader="dots"
             color="#ffc107"
             :height="125"
             :width="170"
             background-color="#F7F7F9"
             :is-full-page="true"></loading>
    <div v-if="!this.spinnerVisible">
      <h2 class="page-title">Producci&oacute;n cient&iacute;fica</h2>
      <hr class="hint--rounded">
      <br class="animated fadeIn">
      <b-row>
        <b-col cols="6" lg="3">
          <b-card :no-body="true">
            <b-card-body class="p-0 clearfix">
              <i class="fa fa-user bg-primary p-4 font-2xl mr-3 float-left"></i>
              <div class="h5 text-primary mb-0 pt-3">{{totals.autores}}</div>
              <div class="text-muted text-uppercase font-weight-bold font-xs">Autores</div>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="6" lg="3">
          <b-card :no-body="true">
            <b-card-body class="p-0 clearfix">
              <i class="fa fa-file-pdf-o bg-info p-4 font-2xl mr-3 float-left"></i>
              <div class="h5 text-info mb-0 pt-3">{{totals.articulos}}</div>
              <div class="text-muted text-uppercase font-weight-bold font-xs">Art&iacute;culos</div>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="6" lg="3">
          <b-card :no-body="true">
            <b-card-body class="p-0 clearfix">
              <i class="fa fa-book bg-warning p-4 font-2xl mr-3 float-left"></i>
              <div class="h5 text-warning mb-0 pt-3">{{totals.libros}}</div>
              <div class="text-muted text-uppercase font-weight-bold font-xs">libros/Capitulos de Libros</div>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="6" lg="3">
          <b-card :no-body="true">
            <b-card-body class="p-0 clearfix">
              <i class="fa fa-product-hunt bg-danger p-4 font-2xl mr-3 float-left"></i>
              <div class="h5 text-danger mb-0 pt-3">{{totals.eventos}}</div>
              <div class="text-muted text-uppercase font-weight-bold font-xs">Ponencias en Eventos</div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row><!--/.row-->

      <!--TABLA DE AUTORES-->
      <b-row offset-md="">
        <b-col align-h="left" cols="8" class="tabla-autores">
          <b-col md="6" style="padding-top: 3%">
            <h5 class="text-uppercase font-weight-bold" style="padding-top: 5%">Productividad de los autores</h5>
          </b-col>

          <b-row>
            <b-table responsive hover :sort-by.sync="table.sortBy" :items="autorproduccion"
                     :fields="this.table.fields"
                     :sort-desc.sync="table.sortDesc"
                     :per-page="table.perPage"
                     :current-page="table.currentPage"
                     style="color:#1E3375; max-width: 98%; padding-left: 10px">

              <template slot="show_details" slot-scope="row">
                <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
                <b-button size="sm" @click="cargarPublicaciones(row.item.id )" @click.stop="row.toggleDetails"
                          variant="light" class="btn btn-pill mr-2">
                  {{ row.detailsShowing ? 'Ocultar' : 'Mostrar'}}
                </b-button>
                <!-- In some circumstances you may need to use @click.native.stop instead -->
                <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
              </template>

              <template slot="row-details" slot-scope="row">
                <b-card>
                  <b-row class="mb-2" v-if="autor_articulo.articulos!=0">
                    <b-col cols md="auto" class="text-sm-left"><span class="font-weight-bold">Artículos: </span>
                    </b-col>
                    <b-col cols md="10">
                      <ul class="list-group list-group-flush">
                        <li class="list-group-item investigador" v-for="item in autor_articulo.articulos">
                          {{ item.titulo }}
                        </li>
                      </ul>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2" v-if="autor_articulo.eventos!=0">
                    <b-col cols md="auto" class="text-sm-left"><span class="font-weight-bold">Eventos: </span>
                    </b-col>
                    <b-col cols md="10">
                      <ul class="list-group list-group-flush">
                        <li class="list-group-item investigador" v-for="item in autor_articulo.eventos">
                          {{ item.titulo }}
                        </li>
                      </ul>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2" v-if="autor_articulo.libros!=0">
                    <b-col cols md="auto" class="text-sm-left"><span class="font-weight-bold">Libros/Capitulos de Libros: </span>
                    </b-col>
                    <b-col cols md="10">
                      <ul class="list-group list-group-flush">
                        <li class="list-group-item investigador" v-for="item in autor_articulo.libros">
                          {{ item.titulo }}
                        </li>
                      </ul>
                    </b-col>
                  </b-row>
                  <!--<b-row class="mb-2">
                    <b-col sm="3" class="text-sm-right"><b>Is Active:</b></b-col>
                    <b-col>{{ row.item.isActive }}</b-col>
                  </b-row>-->
                  <!--<b-button size="sm" @click="row.toggleDetails" class="btn btn-pill btn-block btn-warning">Ocultar Problema</b-button>-->
                </b-card>
              </template>

            </b-table>
          </b-row>


          <b-row align-h="center">
            <b-col md="6" class="my-1">
              <b-pagination align="center" :total-rows="countautorproduccion" :per-page="table.perPage"
                            v-model="table.currentPage"
                            :hide-goto-end-buttons="true"
                            prev-text='<i class="fa fa-caret-left" style="font-size:xx-large!important;color:#D5D9DE"></i>'
                            next-text='<i class="fa fa-caret-right" style="font-size:xx-large!important;color:#D5D9DE"></i>'
                            class="pagination" style=""/>
            </b-col>
          </b-row>

        </b-col>

        <b-col v-if="this.totals" md="4">
          <b-row md="2" class="cont_percent">
            <b-col class="container4" md="3" offset-md="2">
              <h5>ARTÍCULOS</h5>
            </b-col>
            <b-col align-self="start" md="auto" class="container_percent">
              <vue-circle ref="articulosCircle"
                          :progress="this.articulosPercent"
                          :size="100"
                          :reverse="false"
                          line-cap="round"
                          :fill="{color:'#14245F'}"
                          empty-fill="#D5D9DE"
                          :animation-start-value="0.0"
                          :start-angle="0"
                          insert-mode="append"
                          :thickness="5"
                          :show-percent="true">
                <!--<p>Slot!</p>-->
              </vue-circle>
            </b-col>
          </b-row>

          <b-row md="2" class="cont_percent">
            <b-col class="container4" md="3" offset-md="2">
              <h5>EVENTOS</h5>
            </b-col>
            <b-col align-self="start" md="auto" class="container_percent">
              <vue-circle
                :progress="this.eventosPercent"
                :size="100"
                :reverse="false"
                line-cap="round"
                :fill="{color:'#F58220'}"
                empty-fill="#D5D9DE"
                :animation-start-value="0.0"
                :start-angle="0"
                insert-mode="append"
                :thickness="5"
                :show-percent="true">
                <!-- <p>Slot!</p>-->
              </vue-circle>
            </b-col>
          </b-row>

          <b-row md="2" class="cont_percent">
            <b-col class="container4" md="3" offset-md="2">
              <h5>LIBROS</h5>
            </b-col>
            <b-col align-self="start" md="auto" class="container_percent">
              <vue-circle
                :progress="this.librosPercent"
                :size="100"
                :reverse="false"
                line-cap="round"
                :fill="{color:'#898693'}"
                empty-fill="#D5D9DE"
                :animation-start-value="0.0"
                :start-angle="0"
                insert-mode="append"
                :thickness="5"
                :show-percent="true">
                <!-- <p>Slot!</p>-->
              </vue-circle>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!--<b-row align-h="center">
        <b-col md="6" class="">
          <b-pagination :total-rows="countautorproduccion" :per-page="table.perPage" v-model="table.currentPage"
                        class="my-0"/>
        </b-col>
      </b-row>-->
      <br/>
      <!--FIN TABLA DE AUTORES-->
      <b-row align-h="start" style="margin-top: 20px;margin-bottom: 10px">
        <b-col cols="12" class="grafica_label_izq">
          <h3 class="text-center font-weight-bold">Producci&oacute;n en UAPA</h3>
          <hr>
        </b-col>
      </b-row>

      <b-row align-h="center">
        <b-col cols="auto">
          <date-picker
            v-model="fechaRango" lang="es" range
            type="year" format="YYYY"
            confirm-text="Aceptar"
            :shortcuts="false"
            @change="actualizarEstadisticas()"
            confirm></date-picker>
        </b-col>
      </b-row>
      <br/>

      <b-row></b-row>

      <b-row align-h="center">
        <b-col cols="8" class="grafica_background">
          <bar-problemas :chart-data="unidosCharData" :width="400" :height="400"/>
        </b-col>
      </b-row>

      </br>
      </br>
      <b-row align-h="start" style="margin-top: 20px;margin-bottom: 10px">
        <b-col cols="3" align-self="start" class="grafica_label_izq">
          <h5 class="text-right font-weight-bold">Total de artículos por año</h5>
          <hr>
        </b-col>
        <b-col cols="2" offset-md="2" class="grafica_label_center">
          <h5 class="text-right font-weight-bold">Total de eventos por año</h5>
          <hr>
        </b-col>
        <b-col cols="3" offset-md="2" class="grafica_label_der">
          <h5 class="text-left font-weight-bold">Total de cap&iacute;tulos de libros por año</h5>
          <hr>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="4">
          <bar-problemas :chart-data="articulosCharData" :width="400" :height="400"/>
        </b-col>
        <b-col cols="4">
          <bar-problemas :chart-data="eventosCharData" :width="400" :height="400"/>

        </b-col>
        <b-col cols="4">
          <bar-problemas :chart-data="librosCharData" :width="400" :height="400"/>
        </b-col>
      </b-row>


    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapState} from 'vuex'
  import {mapWaitingActions, mapWaitingGetters} from 'vue-wait'
  import BarProblemas from "../graficas/problemas/barProblemas"
  import VueCircle from 'vue2-circle-progress'
  import DatePicker from 'vue2-datepicker'
  import moment from 'moment'
  import {eventHub} from '../../eventhub'
  import {CircleLoader} from '@saeris/vue-spinners'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import axios from 'axios'

  var groupArray = require('group-array')


  export default {
    name: "publicaciones",
    components: {
      BarProblemas,
      VueCircle,
      DatePicker,
      Loading
    },
    comments: {},
    data: function () {
      return {
        articulosCharData: [],
        eventosCharData: [],
        librosCharData: [],
        unidosCharData: [],
        probando: [],
        articuloPorcientos: 0,
        eventosPorcientos: 0,
        librosPorcientos: 0,
        fechaRango: '',
        spinnerVisible: true,
        options: {
          color: '#007AFF',
          strokeWidth: 0.5
        },
        fill: {gradient: ["blue"]},
        table: {
          sortBy: 'total',
          sortDesc: true,
          perPage: 10,
          currentPage: 1,
          fields: {
            nombre: {
              sortable: false
            },
            articulos: {
              sortable: true, label: 'Artículos'
            },
            eventos: {
              sortable: true
            },
            libros: {
              sortable: true
            },
            total: {
              sortable: true,
            },
            show_details: {label: 'Evidencias'},
          }
        },
        autor_articulo: []
      }
    },
    methods: {
      ...mapActions(['getAutoresProduccion', 'getproduccionCientifica', 'getTotales', 'getRevistas', 'getEventos']),
      graficarArticulos() {
        this.articulosCharData = {
          labels: Object.keys(this.produccionCientificaCounter.articulos),
          datasets: [
            {
              label: 'Artículos',
              backgroundColor: '#F58220',
              data: Object.values(this.produccionCientificaCounter.articulos)
            }
          ]
        }
      },
      graficarEventos() {
        this.eventosCharData = {
          labels: Object.keys(this.produccionCientificaCounter.eventos),
          datasets: [
            {
              label: 'Eventos',
              backgroundColor: '#041147',
              data: Object.values(this.produccionCientificaCounter.eventos)
            }
          ]
        }
      },
      graficarLibros() {
        this.librosCharData = {
          labels: Object.keys(this.produccionCientificaCounter.libros),
          datasets: [
            {
              label: 'Capítulos de libros',
              backgroundColor: '#898693',
              data: Object.values(this.produccionCientificaCounter.libros)
            }
          ]
        }
      },
      graficarUnidos() {
        var cantidadesArticulos = Object.values(this.produccionCientificaCounter.articulos)
        var cantidadesEventos = Object.values(this.produccionCientificaCounter.eventos)
        var cantidadesLibros = Object.values(this.produccionCientificaCounter.libros)

        var libros = Object.keys(this.produccionCientificaCounter.libros)
        var eventos = Object.keys(this.produccionCientificaCounter.eventos)
        var articulos = Object.keys(this.produccionCientificaCounter.articulos)
        var labelsUnidos = Array.from(new Set((libros.concat(eventos).concat(articulos)).sort()))


        var item
        for (item in labelsUnidos) {
          if (!articulos.includes(labelsUnidos[item])) {
            cantidadesArticulos.splice(item, 0, 0)
          }
          if (!eventos.includes(labelsUnidos[item])) {
            cantidadesEventos.splice(item, 0, 0)
          }
          if (!libros.includes(labelsUnidos[item])) {
            cantidadesLibros.splice(item, 0, 0)
          }
        }

        this.unidosCharData = {
          labels: labelsUnidos,
          datasets: [
            {
              label: 'Artículos',
              backgroundColor: '#F58220',
              data: cantidadesArticulos
            },
            {
              label: 'Eventos',
              backgroundColor: '#041147',
              data: cantidadesEventos
            },
            {
              label: 'Capítulos de libros',
              backgroundColor: '#898693',
              data: cantidadesLibros
            }
          ]
        }
      },
      cargarDatosTabla() {
      },
      actualizarEstadisticas() {
        //alert(moment(this.fechaRango[0]).year())
        let payload = {
          first_year: moment(this.fechaRango[0]).year(),
          last_year: moment(this.fechaRango[1]).year()
        }
        this.getproduccionCientifica(payload)
        setTimeout(() => {
          this.graficarUnidos()
          this.graficarArticulos()
          this.graficarEventos()
          this.graficarLibros()
        }, 150)
      },
      progress(event, progress, stepValue) {
        console.log(stepValue);
      },
      progress_end(event) {
        console.log("Circle progress end");
      },
      showSpinner() {
        console.log('show spinner');
        this.spinnerVisible = true;
      },
      hideSpinner() {
        console.log('hide spinner');
        this.spinnerVisible = false;
      },
      async cargarPublicaciones(id) {
        var obj = this
        this.autor_articulo = []
        console.log(id)
        axios.defaults.headers.common['Authorization'] = '';
        const url = 'http://10.1.110.121:8000/publicaciones/autor/'
        await axios.get(url + id, {}).then((response) => {
          obj.autor_articulo = response.data
        }).catch(error => {
          obj.autor_articulo = []
        })
        //alert('sdfsdfsdf')
      }
    },
    beforeUpdate() {
    },
    created() {
      eventHub.$on('before-request', this.showSpinner);
      eventHub.$on('request-error', this.hideSpinner);
      eventHub.$on('after-response', this.hideSpinner);
      eventHub.$on('response-error', this.hideSpinner);
      this.$store.dispatch({
        type: 'getAutoresProduccion',
        timeout: 100,
        payload: {
          first_year: moment().year() - 10,
          last_year: moment().year(),
        }
      })
      setTimeout(() => {
        this.getTotales()
        let payload = {
          first_year: moment().year() - 10,
          last_year: moment().year()
        }
        this.getproduccionCientifica(payload).then(
          () => {
            this.graficarEventos()
            this.graficarLibros()
            this.graficarUnidos()
            this.graficarArticulos()
            console.log('Llegoooooooooooo')
          })
      }, 150)
      console.log('created')
      //this.getAutoresProduccion()
      if (this.spinnerVisible) {
        setTimeout(() => {
          this.graficarEventos()
          this.graficarLibros()
          this.graficarUnidos()
          this.graficarArticulos()
        }, 150)
      }
      console.log('ok')
    },
    mounted() {
    },
    computed: {
      ...mapGetters(['autorproduccion', 'countautorproduccion']),
      ...mapState({
        a: state => groupArray(state.publicaciones.articulos, 'ano'),
        produccionCientificaCounter: state => state.publicaciones.produccion_cientifica,
        totals: state => state.publicaciones.totales
      }),
      articulosPercent() {
        if (!sessionStorage.getItem('totales')) {
          let percent = Math.round((this.totals.articulos * 100) / (this.totals.articulos + this.totals.eventos + this.totals.libros))
          return percent
        } else {
          let totales = JSON.parse(sessionStorage.getItem('totales'))
          let percent = Math.round((totales.articulos * 100) / (totales.articulos + totales.eventos + totales.libros))
          return percent
        }
      },
      eventosPercent() {
        if (!sessionStorage.getItem('totales')) {
          let percent = Math.round((this.totals.eventos * 100) / (this.totals.articulos + this.totals.eventos + this.totals.libros))
          return percent
        } else {
          let totales = JSON.parse(sessionStorage.getItem('totales'))
          let percent = Math.round((totales.eventos * 100) / (totales.articulos + totales.eventos + totales.libros))
          return percent
        }
      },
      librosPercent() {
        if (!sessionStorage.getItem('totales')) {
          let percent = Math.round((this.totals.libros * 100) / (this.totals.articulos + this.totals.eventos + this.totals.libros))
          return percent
        } else {
          let totales = JSON.parse(sessionStorage.getItem('totales'))
          let percent = Math.round((totales.libros * 100) / (totales.articulos + totales.eventos + totales.libros))
          return percent
        }
      },
    },
    beforeDestroy() {
      eventHub.$off('before-request', this.showSpinner);
      eventHub.$off('request-error', this.hideSpinner);
      eventHub.$off('after-response', this.hideSpinner);
      eventHub.$off('response-error', this.hideSpinner);
    }
  }
</script>

<style scoped>
  .fa {
    color: white;
  }

  .tabla-autores {
    background-color: rgba(213, 217, 222, 0.18);
    border-radius: 23px;
  }

  /*.table-borderless td,
  .table-borderless th {
    border: 0;
  }

  div.container4 {
    background-color: #F7F7F9;
    border-bottom-left-radius: 23px;
    border-top-left-radius: 23px;
  }

  .container_percent {
    background-color: #F7F7F9;
    border-top-right-radius: 23px;
    border-bottom-right-radius: 23px;
  }

  h5, h3 {
    color: #1E3375;
  }

  div.container4 h5 {
    margin: 0;
    !*background: yellow;*!
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    margin-left: 10px;
    transform: translate(-50%, -50%);
    border-bottom-left-radius: 23px !important;
  }*/

  .cont_percent {
    margin-bottom: 10px;
  }

  .grafica_label_izq {
    border-top-right-radius: 23px;
    border-bottom-right-radius: 23px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 30px;
  }

  .grafica_label_center {
    border-radius: 23px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 30px;
  }

  .grafica_label_der {
    border-bottom-left-radius: 23px;
    border-top-left-radius: 23px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 30px;
  }

  .grafica_background {

    border-radius: 23px;
  }

  /*.page-link {
    border-color: transparent !important;
  }

  .pagination li, .page-item .page-link {
    background-color: transparent !important;
    color: #1E3375 !important;
    font-size: x-large;
  }

  .page-link:focus, .pagination-datatables li a:focus, .pagination li a:focus {
    box-shadow: 0 0 0 0 transparent !important;
    color: #FAA61A !important;
  }

  .page-link {
    border-color: transparent !important;
  }

  .pagination li, .page-item .page-link {
    background-color: transparent !important;
    color: #1E3375 !important;
    font-size: x-large;
  }

  .page-link:focus, .pagination-datatables li a:focus, .pagination li a:focus {
    box-shadow: 0 0 0 0 transparent !important;
    color: #FAA61A !important;
  }*/

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 5;
    width: 100%;
    height: 100%;
    display: none;
  }

  .circle {
    margin-bottom: 10px;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/frontend/publicaciones.vue